import * as actionType from "./action";

export function kibanaReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.KIBANA_LOGIN_SUCCESS:
      return { ...state, response };
    case actionType.KIBANA_LOGIN_ERROR:
      return { ...state, response };
    default:
      return state;
  }
}
